import { useMemo } from 'react';

import { FOOD_TYPE, FoodType } from '../../../constants/foodType';
import {
  barcodeFoodsListStore,
  coreFoodsListStore,
  FoodsListStore,
  supplementFoodsListStore,
  veggiesFoodsListStore,
} from '../../../stores/foodsListStore';

export const useFoodsListStore = (foodType: FoodType): FoodsListStore => {
  if (!foodType) {
    throw new Error('useFoodsListStore: foodType is required');
  }

  const stores: Record<FoodType, FoodsListStore> = {
    [FOOD_TYPE.CORE]: coreFoodsListStore,
    [FOOD_TYPE.SUPPLEMENT]: supplementFoodsListStore,
    [FOOD_TYPE.VEGGIES]: veggiesFoodsListStore,
    [FOOD_TYPE.BARCODE]: barcodeFoodsListStore,
  };

  return useMemo(() => {
    return stores[foodType];
  }, [foodType]);
};
